import { CheckCircle2 } from "lucide-react";
import { Reveal } from "../site/Motion";
import { SectionLabel } from "../site/Bits";
import { APP_SCREENSHOTS } from "../../lib/site";

const points = [
  "Automatically tracks every expiry date for you",
  "Sends email & push reminders before items lapse",
  "Keeps licences, permits & documents audit-ready",
  "Works for whole teams — and for personal use",
];

export const WhatItDoes = () => (
  <section className="relative bg-white py-24" data-testid="what-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <div className="relative">
          <div className="overflow-hidden rounded-3xl border border-slate-200 shadow-xl">
            <img
              src={APP_SCREENSHOTS.documents}
              alt="Organised compliance documents"
              className="h-[420px] w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 hidden rounded-2xl border border-slate-100 bg-white px-5 py-4 shadow-xl sm:block">
            <p className="font-display text-2xl font-bold text-brand">Zero</p>
            <p className="text-xs font-medium text-slate-500">missed deadlines</p>
          </div>
        </div>
      </Reveal>

      <div>
        <SectionLabel>What RenewTracker does</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl">
          One secure place for every important deadline.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          Managing renewal dates across vehicles, employees, equipment, licences, permits, contracts and subscriptions quickly becomes overwhelming. A single missed renewal can mean fines, legal issues or business disruption. RenewTracker keeps it all organised and reminds you in time.
        </p>
        <ul className="mt-8 space-y-4">
          {points.map((p, i) => (
            <Reveal key={p} delay={i * 0.08}>
              <li className="flex items-start gap-3">
                <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-greenaccent/15">
                  <CheckCircle2 className="h-4 w-4 text-greenaccent" />
                </span>
                <span className="text-[15px] font-medium text-slate-700">{p}</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default WhatItDoes;
